import React, { useState, useEffect, useCallback } from 'react';
import { Typography, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, CircularProgress, Box, Button, Grid, TextField, FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import { getSolicitudes } from '../services/api';
import { useNavigate } from 'react-router-dom';

function DashboardPage() {
  const [solicitudes, setSolicitudes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const navigate = useNavigate();
  
  const [filters, setFilters] = useState({
    estatus: '',
    tipo_solicitud: '',
    descripcion: ''
  });

  const fetchSolicitudes = useCallback(async (currentFilters) => {
    setLoading(true);
    try {
      const activeFilters = Object.fromEntries(
        Object.entries(currentFilters).filter(([_, value]) => value !== '')
      );
      const response = await getSolicitudes(activeFilters);
      setSolicitudes(response.data);
    } catch (err) {
      setError('Error al cargar las solicitudes. Por favor, intente de nuevo.');
      console.error(err);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchSolicitudes(filters);
  }, [fetchSolicitudes]);

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters(prev => ({ ...prev, [name]: value }));
  };

  const handleApplyFilters = () => {
    fetchSolicitudes(filters);
  };

  const handleClearFilters = () => {
    const clearedFilters = { estatus: '', tipo_solicitud: '', descripcion: '' };
    setFilters(clearedFilters);
    fetchSolicitudes(clearedFilters);
  };

  const handleRowClick = (id) => {
    navigate(`/dashboard/solicitud/${id}`);
  };

  return (
    <>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
        <Typography variant="h4" gutterBottom>
          Gestión de Solicitudes
        </Typography>
        <Button variant="contained" onClick={() => navigate('/dashboard/stats')}>
          Ver Estadísticas
        </Button>
      </Box>

      <Paper elevation={2} sx={{ p: 2, mb: 3 }}>
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12} sm={3}>
            <FormControl fullWidth>
              <InputLabel>Estatus</InputLabel>
              <Select name="estatus" value={filters.estatus} label="Estatus" onChange={handleFilterChange}>
                <MenuItem value=""><em>Todos</em></MenuItem>
                <MenuItem value="RECIBIDO">Recibido</MenuItem>
                <MenuItem value="EN_PROCESO">En Proceso</MenuItem>
                <MenuItem value="RESUELTO">Resuelto</MenuItem>
                <MenuItem value="CERRADO">Cerrado</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={3}>
            <FormControl fullWidth>
              <InputLabel>Tipo</InputLabel>
              <Select name="tipo_solicitud" value={filters.tipo_solicitud} label="Tipo" onChange={handleFilterChange}>
                <MenuItem value=""><em>Todos</em></MenuItem>
                <MenuItem value="QUEJA">Queja</MenuItem>
                <MenuItem value="DENUNCIA">Denuncia</MenuItem>
                <MenuItem value="PETICION">Petición</MenuItem>
                <MenuItem value="RECLAMO">Reclamo</MenuItem>
                <MenuItem value="SUGERENCIA">Sugerencia</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={3}>
            <TextField fullWidth label="Buscar en descripción" name="descripcion" value={filters.descripcion} onChange={handleFilterChange} />
          </Grid>
          <Grid item xs={12} sm={3}>
            <Box sx={{ display: 'flex', gap: 1 }}>
              <Button variant="contained" onClick={handleApplyFilters} fullWidth>Filtrar</Button>
              <Button variant="outlined" onClick={handleClearFilters} fullWidth>Limpiar</Button>
            </Box>
          </Grid>
        </Grid>
      </Paper>

      {loading ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', mt: 5 }}><CircularProgress /></Box>
      ) : error ? (
        <Typography color="error">{error}</Typography>
      ) : (
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 650 }} aria-label="tabla de solicitudes">
            <TableHead>
              <TableRow>
                <TableCell>Código de Seguimiento</TableCell>
                <TableCell>Tipo</TableCell>
                <TableCell>Ciudadano</TableCell>
                <TableCell>Fecha Creación</TableCell>
                <TableCell>Estatus</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {solicitudes.map((solicitud) => (
                <TableRow
                  key={solicitud.id}
                  hover
                  onClick={() => handleRowClick(solicitud.id)}
                  sx={{ cursor: 'pointer' }}
                >
                  <TableCell component="th" scope="row">{solicitud.codigo_seguimiento}</TableCell>
                  <TableCell>{solicitud.tipo_solicitud}</TableCell>
                  <TableCell>{solicitud.nombre_ciudadano || 'Anónimo'}</TableCell>
                  <TableCell>{new Date(solicitud.fecha_creacion).toLocaleDateString()}</TableCell>
                  <TableCell>{solicitud.estatus}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </>
  );
}

export default DashboardPage;